import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const SilentAuth = () => {
  const { user, loading, checkAuth } = useAuth();
  
  const wasLoggedIn = React.useRef(false);
  
  useEffect(() => {
    // 1. Storage Listener for cross-tab login/logout detection
    const handleStorageChange = (event) => {
      if (event.key === 'token') {
        if (!event.newValue) {
          // Token was explicitly removed (Logout)
          window.parent.postMessage({ type: 'VIEWGATE_LOGOUT' }, '*');
          wasLoggedIn.current = false;
        } else {
          // Token was added (Login)
          checkAuth();
        }
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [checkAuth]);

  useEffect(() => {
    if (!loading) {
      if (user) {
        const token = localStorage.getItem('token');
        wasLoggedIn.current = true;
        // Notify the parent (the wrapper iframe) about the existing session
        window.parent.postMessage({
          type: 'VIEWGATE_SILENT_AUTH',
          token,
          user,
          role: user.role || 'dev'
        }, '*');
      } else if (wasLoggedIn.current) {
        // Only notify logout if we were previously logged in during this iframe session
        window.parent.postMessage({ type: 'VIEWGATE_LOGOUT' }, '*');
        wasLoggedIn.current = false;
      }
      // If none of the above, we stay silent to avoid clearing manual logins in the wrapper
      // when this iframe might be "blind" to cross-origin storage.
    }
  }, [user, loading]);

  // This page is meant to be hidden in an iframe
  return null;
};

export default SilentAuth;
